import dayjs from 'dayjs';
import RelativeTime from 'dayjs/plugin/relativeTime';
import UTC from 'dayjs/plugin/utc';
import Timezone from 'dayjs/plugin/timezone';
import Weekday from 'dayjs/plugin/weekday';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import WeekOfYear from 'dayjs/plugin/weekOfYear';
import WeekYear from 'dayjs/plugin/weekYear';

dayjs.extend(RelativeTime);
dayjs.extend(UTC);
dayjs.extend(Timezone);
dayjs.extend(Weekday);
dayjs.extend(LocalizedFormat);
dayjs.extend(WeekOfYear);
dayjs.extend(WeekYear);

export default dayjs;
